import React from 'react'
import PropTypes from 'prop-types'
import './PlayerFullscreen.css'

export default class PlayerFullscreen extends React.Component {
	
	render() {
		return (
			<div 
				className="player__fullscreen" 
				onClick={ this.props.onClick }
				/>
		)
	}
}

PlayerFullscreen.propTypes = {
	onClick: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/player/controls/fullscreen/PlayerFullscreen.jsx